module.exports = __webpack_public_path__ + "static/media/newb.f37a64b6.png";